import Icon, { IconProps } from './Icon';

import UploadIcon from '../../../assets/icons/upload-01.svg?react';

const Upload: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <UploadIcon />
        </Icon>
    );
};

export default Upload;
